import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-borders" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "q-mb-md" }, "Reporting", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Allow supervisor report")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Authorized to see whole organization report")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Report items")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_q_list, {
      class: "q-mb-lg",
      bordered: "",
      padding: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_q_badge, {
                    color: _ctx.localModel.allowSupervisorReport ? 'positive' : 'negative',
                    label: _ctx.localModel.allowSupervisorReport.toString()
                  }, null, 8, ["color", "label"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, {
              avatar: "",
              class: "q-ml-auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, { caption: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      label: "Change reporting",
                      onClick: _ctx.onChangeReporting,
                      color: "primary",
                      unelevated: "",
                      "no-caps": ""
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_q_badge, {
                    color: _ctx.localModel.allowInWholeOrganization ? 'positive' : 'negative',
                    label: _ctx.localModel.allowInWholeOrganization.toString()
                  }, null, 8, ["color", "label"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "col-lg-2 col-3 text-right text-weight-medium" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "q-pl-lg" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.localModel.reportItems), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}